<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Available Networks</h1>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Name</th>
                <th class="px-6 pt-6 pb-4">Type</th>
                <th class="px-6 pt-6 pb-4">Status</th>
            </tr>
            <tr v-for="network in networks" :key="network.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ network.name }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ network.type }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">

                        <badge class="mr-2" :type="network.status ? 'green' : 'gray'">
                            {{ network.status ? 'Active' : 'Hidden' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="networks.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No networks found.</td>
            </tr>
        </table>
    </div>
</app-layout>
